import ImgHeader from "../assets/img/header.png";
import Logo from "../assets/img/logo.png";
import ImgAbout from "../assets/img/about.png";
import Carousel1 from "../assets/img/carousel1.png";
import Carousel2 from "../assets/img/carousel2.png";
import Carousel3 from "../assets/img/carousel3.png";
import Carousel4 from "../assets/img/carousel4.png";
import Carousel5 from "../assets/img/carousel5.png";

const company = {
    _id: "5fb282f758e1ee0a116374e3",
    name: "Ken Taki",
    about: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    color: {
        primary: "#750038",
        secondary: "#e9b200",
    },
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
    site: "https://kentaki.com.br",
    facebook: "https://www.facebook.com/kentakioriental/",
    instagram: "https://www.instagram.com/ken.taki/",
    image: {
        header: ImgHeader,
        logo: Logo,
        about: ImgAbout,
        carousel: [
            { image: Carousel1 },
            { image: Carousel2 },
            { image: Carousel3 },
            { image: Carousel4 },
            { image: Carousel3 },
            { image: Carousel5 },
        ]
    }

}

export default company;